module.exports = __webpack_public_path__ + "img/czc5082dxt.ea9bd1ff.jpeg";